<template>
  <div>
    <BaseFrame
      cancelText=""
      clearText=""
      :infosArr="infos"
    >
      <div class="container" slot="content">
        <lk-card title="申请明细">
          <div style="display:flex;align-items:center;margin-bottom:12px;">
            <label>生效月份：</label>
            <timeStampDatePicker v-model='month' type="month" style="width:200px;margin:0 12px;"></timeStampDatePicker>
            <lk-button type="primary" @click="handleSearch">查询</lk-button>
          </div>
          <div>
            <lk-table border :columns="columns" :data="tableData"></lk-table>
            <lk-page
              class="pageStyle"
              :total="count"
              :current.sync="page"
              :page-size="size"
              show-sizer
              show-elevator
              show-total
              @on-page-size-change='handlePageSize'
              @on-change='handlePage'
              :page-size-opts='[20,30,50,100]'
            />
          </div>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import utils from '../../libs/utils';
import tools from '../../services/tools';

export default {
  name: 'receiveLimitDetail',
  components: {
    BaseFrame,
  },
  data() {
    return {
      month: '',
      columns: [
        {
          type: 'index',
          title: '序号',
          minWidth: 116,
        },
        {
          title: '申请单号',
          key: 'apprealCode',
          minWidth: 116,
        },
        {
          title: '申请时间',
          key: 'apprealTime',
          minWidth: 116,
        },
        {
          title: '生效月份',
          key: 'takeMouth',
          minWidth: 116,
        },
        {
          title: '申请人',
          key: 'apprealUser',
          minWidth: 116,
        },
        {
          title: '申请数量',
          key: 'apprealNum',
          minWidth: 116,
        },
        {
          title: '已使用数量',
          key: 'usedNum',
          minWidth: 116,
        },
        {
          title: '已过期数量',
          key: 'expireNum',
          minWidth: 116,
        },
        {
          title: '计划回款时间',
          key: 'receivableTime',
          minWidth: 116,
        },
        {
          title: '未到回款日期数量',
          key: 'unReceivableTimeNum',
          minWidth: 116,
        },
        {
          title: '按时回款数量',
          key: 'receivableInTimeNum',
          minWidth: 116,
        },
        {
          title: '超时回款数量',
          key: 'receivableOverNum',
          minWidth: 116,
        },
        {
          title: '超时未回款数量',
          key: 'unReceivableOverNum',
          minWidth: 116,
        },
        {
          title: '最长超时天数',
          key: 'maxOverTime',
          minWidth: 116,
        },
      ],
      tableData: [],
      page: 1,
      size: 20,
      count: 0,
      infos: [],
    };
  },
  methods: {
    handleSearch() {
      const params = {
        page: this.page,
        size: this.size,
        effectMouth: this.month,
        id: this.$route.params.id,
      };
      tools.receiveInDetailSea(params).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          data.list.forEach((item) => {
            item.apprealTime = utils.formatDateToSecond(item.apprealTime);
            item.takeMouth = utils.formatDateToMonth(item.takeMouth);
            item.receivableTime = utils.formatDate(item.receivableTime);
          });
          this.tableData = data.list;
          this.count = data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handlePageSize(val) {
      this.size = val;
      this.handleSearch();
    },
    handlePage(val) {
      this.page = val;
      this.handleSearch();
    },
  },
  mounted() {
    this.handleSearch();
    this.infos = [
      {
        name: '门店:',
        value: this.$route.query.store,
      },
      {
        name: '商品:',
        value: this.$route.query.goods,
      },
      {
        name: '单价:',
        value: this.$route.query.price,
      },
    ];
  },
};
</script>
<style lang="less" scoped>
.pageStyle {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
</style>
